import { FC } from 'react'
import { ThemeProvider } from '@emotion/react'
import { theme } from './theme'
import { GlobalProvider } from './contexts/Global'

export const Providers: FC = ({ children }) => {
    return (
        <ThemeProvider theme={theme}>
            <GlobalProvider>{children}</GlobalProvider>
        </ThemeProvider>
    )
}
